import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useTrialSeries() {
  return useQuery({
    queryKey: ["trial-series"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("trial_series_id")
        .eq("id", "global")
        .maybeSingle();

      if (error) throw error;
      return { trialSeriesId: (data as any)?.trial_series_id as string | null };
    },
  });
}

